import React from 'react';

const LandingPage = () => {
  return (
    <div style={{
      backgroundColor: '#ffffff',
      minHeight: '90vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '20px',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h1 style={{
        fontSize: '48px',
        fontWeight: 'bold',
        marginBottom: '20px',
        color: '#4f4f4fff'
      }}>
        Welcome to <span style={{ color: '#FF8C00' }}>Jobs</span><span style={{ color: '#046a38' }}>Yahan</span>
      </h1>

      <p style={{
        fontSize: '18px',
        color: '#666',
        marginBottom: '30px',
        textAlign: 'center',
        maxWidth: '600px'
      }}>
        Admin Portal Dashboard
      </p>

      <div style={{
        backgroundColor: '#f5f5f5',
        padding: '20px 40px',
        borderRadius: '8px',
        marginTop: '20px',
        textAlign: 'center'
      }}>
        <p style={{ color: '#666', margin: '0' }}>
          Manage jobs, employers, candidates, etc. all from here.
        </p>
      </div>
    </div>
  );
};

export default LandingPage;
